import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CartIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.5 14.4805C7.5 15.1709 6.94036 15.7305 6.25 15.7305C5.55964 15.7305 5 15.1709 5 14.4805C5 13.7901 5.55964 13.2305 6.25 13.2305C6.94036 13.2305 7.5 13.7901 7.5 14.4805Z"
		/>
		<path
			fill="currentColor"
			d="M13.5 14.4805C13.5 15.1709 12.9404 15.7305 12.25 15.7305C11.5596 15.7305 11 15.1709 11 14.4805C11 13.7901 11.5596 13.2305 12.25 13.2305C12.9404 13.2305 13.5 13.7901 13.5 14.4805Z"
		/>
		<path
			fill="currentColor"
			d="M1.75012 1.72552C1.33314 1.72552 0.995117 2.06355 0.995117 2.48053C0.995117 2.8975 1.33314 3.23553 1.75012 3.23553H2.61993C3.21076 3.23553 3.72022 3.65078 3.83936 4.22947L5.26063 12.1327C5.33288 12.4837 5.64183 12.7355 6.00012 12.7355H12.5001C12.5297 12.7355 12.5588 12.7338 12.5874 12.7305H12.6916C13.1631 12.7305 13.5706 12.4011 13.6694 11.94L14.9778 6.94006C15.1112 6.31755 14.6366 5.73053 14 5.73053H5.48419L5.31834 3.92497C5.0547 2.64442 3.92734 1.72552 2.61993 1.72552H1.75012Z"
		/>
	</svg>
))
